import React, { useEffect, useState, forwardRef } from 'react';

import {
    Box,
    Grid,
    Divider,
    styled,
    Chip,
    Link,
    Typography,
    Badge,
    Card
} from '@mui/material';

// import { useSystemUtils } from "../../hooks/useSystemUtils"

import CommonSectionHeader from '../common/CommonSectionHeader';
import { CommonIcons, icons } from '../common/CommonIcons';

import { dependencyModules, targetTypes as dependencyTargetTypes, dependencyRefs, useDependencies } from '../../hooks/api/useDependencies';
import { useSystemRoutes, routeTypes } from '../../hooks/useSystemRoutes';
import { useTranslations } from '../../hooks/useTranslations';

const StyledDivider = styled(Divider)(({ theme }) => ({
    mt: 1,
    mb: 0,
    borderStyle: 'dashed'
}))

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(3)
}));

export default function ViewDocumentDependency({
    routeType,
    data,
    disableViewLink = false
}) {
    const { t } = useTranslations({ ns: ["common", "@document"] })

    const { getRoute } = useSystemRoutes(routeType)

    const { getViewUrl } = useDependencies()

    // console.log('data', data)

    let dataInward = data?.inward_dependencies ? data.inward_dependencies : []
    let dataOutward = data?.outward_dependencies ? data.outward_dependencies : []

    if (dataInward.length <= 0 && dataOutward.length <= 0) return <></>

    const getLinkUrl = ({
        // dependencyRef,
        module,
        target,
        targetId
    }) => {

        return getViewUrl({ target, targetId, module })

    }


    const RenderLinkItem = ({ item, bindingType = '' }) => {

        let url = '';
        let display = ''

        // {
        //     "refer_id": "1530",
        //     "document_id": "1526",
        //     "document_number": "INV-240700021",
        //     "document_date": "2024-07-19",
        //     "target": "document",
        //     "module": "SALES_INVOICE"
        // }

        const {
            refer_id: referId,
            document_id: documentId,
            document_number: documentNumber,
            document_date: documentDate,
            target,
            module
        } = item

        url = getLinkUrl({
            module,
            target,
            targetId: documentId
        })

        display = `${documentNumber} (${documentDate})`

        // if (bindingType === "in") {
        //     // inward
        //     url = getLinkUrl({
        //         module: item?.module,
        //         target: item?.target,
        //         dependencyRef: item?.dependency_ref,
        //         targetId: item?.document_id
        //     })

        //     display = `${item?.document_number} (${item?.document_date})`

        // } else {
        //     // outward
        //     url = getLinkUrl({
        //         module: item?.module,
        //         target: item?.target,
        //         dependencyRef: item?.dependency_ref,
        //         targetId: item?.target_id
        //     })

        //     display = `${item?.target_document_number} (${item?.target_document_date})`

        // }


        url = getRoute(url)

        // console.log('disableViewLink', disableViewLink)

        return (
            <Link
                {
                ...(disableViewLink === false) ?
                    {
                        href: url,
                        target: '_blank',
                        underline: 'hover',
                        rel: 'noopener'
                    } : {}
                }
            >
                <Box
                    display={"flex"}
                    flexDirection={"row"}
                    justifyContent={"flex-end"}
                    alignItems={"center"}
                >
                    <CommonIcons name={icons.dependency} />
                    <Badge
                        badgeContent={`${bindingType}`}
                        color={"primary"}
                    >
                        <Typography
                            sx={{
                                fontSize: 15,
                                fontWeight: '600',
                                ml: 1
                            }}
                        >
                            {display}
                        </Typography>
                    </Badge>
                </Box>

            </Link>
        )
    }

    return (
        <StyledCard sx={{ mt: 1 }}>
            <Grid container spacing={1}>
                <Grid item xs={6} sm={6} md={6} textAlign={"left"}>

                    <CommonSectionHeader
                        title={t(`relatedDocument`)}
                        subTitle={t('relatedDocumentAttached')}
                    />

                </Grid>

                {/* <Grid item xs={12}>
                <StyledDivider />
            </Grid> */}

                <Grid
                    item
                    xs={6} sm={6} md={6}
                    sx={{}}
                // display={"flex"}
                // flexDirection={"row"}
                // justifyContent={"flex-end"}
                // alignItems={"center"}
                >

                    {
                        dataInward.map((i, index) => {
                            return (
                                <RenderLinkItem
                                    bindingType={"in"}
                                    key={index}
                                    item={i}
                                />
                            )
                        })
                    }

                    {
                        dataOutward.map((i, index) => {
                            return (
                                <RenderLinkItem
                                    bindingType={"out"}
                                    key={index}
                                    item={i}
                                />
                            )
                        })
                    }

                    {/* <Chip
                    label={JSON.stringify(data)}
                    variant='outlined'
                /> */}
                </Grid>

            </Grid>
        </StyledCard>
    )

}